var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "57.4 38.45 36 27.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.3971 58.3172C78.2051 58.3172 80.5091 56.0961 80.5091 53.3515C80.5091 50.6068 78.2051 48.3857 75.3971 48.3857C72.5711 48.3857 70.2671 50.6068 70.2671 53.3515C70.2671 56.0961 72.5711 58.3172 75.3971 58.3172Z",
    fill: "url(#paint0_linear_3_277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3404 42.065H84.1284C83.5344 42.065 83.0124 41.7039 82.8324 41.1802C82.2744 39.5551 80.7264 38.4536 78.9804 38.4536H71.7984C70.0524 38.4536 68.5044 39.5551 67.9464 41.1802C67.7664 41.7039 67.2444 42.065 66.6504 42.065H65.6424V41.6136C65.6424 40.8733 65.0304 40.2593 64.2924 40.2593C63.5364 40.2593 62.9424 40.8733 62.9424 41.6136V42.065H62.4384C59.6484 42.065 57.3984 44.2861 57.3984 47.0308V61.4765C57.3984 64.2212 59.6484 66.4422 62.4384 66.4422H88.3404C91.1304 66.4422 93.3984 64.2212 93.3984 61.4765V47.0308C93.3984 44.2861 91.1304 42.065 88.3404 42.065ZM75.3984 45.6765C79.7004 45.6765 83.2104 49.1254 83.2104 53.3508C83.2104 57.5761 79.7004 61.025 75.3984 61.025C71.0784 61.025 67.5684 57.5761 67.5684 53.3508C67.5684 49.1254 71.0784 45.6765 75.3984 45.6765Z",
    fill: "url(#paint1_linear_3_277)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_277",
    x: 0.325268,
    y: 0.404833,
    width: 150.146,
    height: 142.135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 19.0244
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.5366
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.560784 0 0 0 0 0.541176 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_277"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_277",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_277",
    x1: 67.5505,
    y1: 44.566,
    x2: 80.2509,
    y2: 47.8503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78B88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_277",
    x1: 47.8497,
    y1: 27.6888,
    x2: 90.9884,
    y2: 41.6024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECE76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78B88"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.084ed73bb1558e4583e1869498406556.svg";
export { ForwardRef as ReactComponent };